import React, { useState, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
import classes from "./CreatePostPopup.module.css";
import Portal from "../../../utils/Portal";
import { usePopper } from "react-popper";
import { ScrollContainer } from "react-indiana-drag-scroll";
import "react-indiana-drag-scroll/dist/style.css";
import { useDispatch } from "react-redux";
import * as createPostSlice from "../../../app/slices/createPostSlice";

function EmojiPickerBackground({
  postTextRef,
  postText,
  setPostText,
  picker,
  setPicker,
  createPost,
  postBackgrounds,
}) {
  const dispatch = useDispatch();

  const [referenceElement, setReferenceElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);
  const [cursorPosition, setCursorPosition] = useState();
  const [showBgs, setShowBgs] = useState(false);

  useEffect(() => {
    if (!postTextRef.current) return;
    postTextRef.current.focus();
    postTextRef.current.selectionEnd = cursorPosition;
  }, [cursorPosition, postTextRef]);

  useEffect(() => {
    if (!postTextRef.current) return;
    postTextRef.current.focus();
  }, [picker, postTextRef]);

  const handleEmoji = ({ e, emoji }) => {
    const ref = postTextRef.current;
    ref.focus();
    const start = postText.substring(0, ref.selectionStart);
    const end = postText.substring(ref.selectionStart);
    const newText = start + emoji + end;
    setPostText(newText);
    setCursorPosition(start.length + emoji.length);
  };

  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: "top",
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 10],
        },
      },
    ],
  });
  return (
    <div className={classes.emoji_wrap} id="CreatePostPopup">
      {createPost.type === "image" ? (
        ""
      ) : (
        <div className={classes.background_wrap}>
          <button
            type="button"
            className={classes.open_bg}
            aria-label="Choose an update background"
            aria-expanded={showBgs}
            aria-controls="create-post-backgrounds"
            data-testid="create-post-background-toggle"
            onClick={() => {
              setShowBgs((prev) => !prev);
            }}
          >
            <img src="../../../icons/colorful.png" alt="" />
          </button>
          {showBgs && (
            <ScrollContainer
              className={classes.backgrounds}
              id="create-post-backgrounds"
            >
              <button
                type="button"
                className={classes.no_bg}
                aria-label="Remove update background"
                data-testid="create-post-background-none"
                onClick={() => {
                  dispatch(createPostSlice.type("normal"));
                }}
              ></button>
              {postBackgrounds.map((bg, i) => (
                <button
                  key={i}
                  type="button"
                  className={classes.backgroundOption}
                  aria-label={`Use update background ${i + 1}`}
                  data-testid={`create-post-background-${i + 1}`}
                  onClick={() => {
                    dispatch(createPostSlice.background(i + 1));
                  }}
                >
                  <img src={bg} alt="" />
                </button>
              ))}
            </ScrollContainer>
          )}
        </div>
      )}
      <button
        type="button"
        onClick={() => {
          setPicker((prev) => !prev);
        }}
        className={classes.emojiButton}
        aria-label="Open emoji picker"
        aria-expanded={picker}
        data-testid="create-post-emoji-toggle"
        ref={setReferenceElement}
      >
        <i className="emoji_icon_large" aria-hidden="true"></i>
      </button>
      {picker ? (
        <Portal id="CreatePostPopup">
          <div
            className={classes.emoji_picker}
            ref={setPopperElement}
            style={styles.popper}
            {...attributes.popper}
          >
            <EmojiPicker
              width={300}
              height={300}
              lazyLoadEmojis={true}
              onEmojiClick={handleEmoji}
              previewConfig={{ showPreview: false }}
            />
          </div>
        </Portal>
      ) : (
        ""
      )}
    </div>
  );
}

export default EmojiPickerBackground;
